import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function DynamicImageRender({ node, isLiveMode, pageData }) {
  const content = node.content || {};
  
  const fieldKey = content.fieldKey || 'meta.coverImage';
  const fallbackUrl = content.fallbackUrl || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600&auto=format&fit=crop';
  
  const width = content.width || '100%';
  const height = content.height || 'auto';
  const objectFit = content.objectFit || 'cover';
  const radius = content.radius || '8px';

  let imageUrl = fallbackUrl;
  
  if (isLiveMode && pageData) {
    if (fieldKey.startsWith('meta.') && pageData.meta) {
      const metaKey = fieldKey.substring(5);
      imageUrl = pageData.meta[metaKey] || fallbackUrl;
    }
  }

  return (
    <div style={{
      width: width,
      height: height,
      borderRadius: radius,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: 'rgba(255,255,255,0.05)'
    }}>
      {!isLiveMode && (
         <div style={{ position: 'absolute', top: '10px', left: '10px', background: 'rgba(0,0,0,0.7)', color: 'white', padding: '4px 8px', fontSize: '11px', borderRadius: '4px', zIndex: 10 }}>
           [Bild aus: {fieldKey}]
         </div>
      )}
      <img 
        src={imageUrl} 
        alt={`Dynamic cover for ${fieldKey}`} 
        style={{ width: '100%', height: '100%', objectFit: objectFit }}
      />
    </div>
  );
}

registry.register('DynamicImage', {
  label: 'Dynamisches Bild (CMS)',
  icon: '🖼️', 
  category: 'advanced', // oder cms
  component: DynamicImageRender,
  
  defaultProps: {
    content: {
      fieldKey: 'meta.coverImage',
      fallbackUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600&auto=format&fit=crop',
      width: '100%',
      height: '300px',
      objectFit: 'cover',
      radius: '12px'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Daten-Bindung',
          fields: [
            { 
              name: 'content.fieldKey', 
              label: 'Metadaten Feld (URL)', 
              type: 'text' // Wir erlauben Text, falls jmd meta.thumbnail oder so baut
            },
            { name: 'content.fallbackUrl', label: 'Fallback Bild URL', type: 'text' }
          ]
        },
        {
          title: 'Abmessungen & Design',
          fields: [
            { name: 'content.width', label: 'Breite (z.B. 100%, 400px)', type: 'text' },
            { name: 'content.height', label: 'Höhe (z.B. 300px, auto)', type: 'text' },
            { name: 'content.objectFit', label: 'Einpassung', type: 'select', options: ['cover', 'contain', 'fill'] },
            { name: 'content.radius', label: 'Eckenradius', type: 'text' }
          ]
        }
      ]
    }
  ]
});
